/**
 * Created by quikr on 12/19/16.
 */
export default class Dates {
  constructor() {

  }

  dateDifference(d1, d2) {
    var one_day = 1000 * 60 * 60 * 24;

    var date1_ms = d1.getTime();
    var date2_ms = d2.getTime();

    // Calculate the difference in milliseconds
    var difference_ms = date2_ms - date1_ms;
    console.log(difference_ms);
    debugger;
    // Convert back to days and return
    return Math.round(difference_ms / one_day);

  }

  getMondayToSunday() {
    let monday = new Date();
    if (monday.getDay() != 1) {
      monday.setDate(monday.getDate() - (monday.getDay() - 1));
    }
    let sunday = new Date();

      sunday.setDate(monday.getDate() + 6);


    return {
      startDate: monday,
      endDate: sunday
    };
  }

  getDates(startDate, stopDate) {

    Date.prototype.addDays = function (days) {
      var dat = new Date(this.valueOf())
      dat.setDate(dat.getDate() + days);
      return dat;
    }
    var dateArray = new Array();
    var currentDate = startDate;
    while (currentDate <= stopDate) {
      dateArray.push(new Date(currentDate))
      currentDate = currentDate.addDays(1);
    }
    return dateArray;
  }

}



/** WEBPACK FOOTER **
 ** ./src/classes/dates.js
 **/